export default __webpack_public_path__ + "static/media/AquaPeel.9eecec0e.png";